import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class SearchBarService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Search bars';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'search-bars/0', 'title': 'Search With Map', 'theme': 'layout1' },
      { 'url': 'search-bars/1', 'title': 'Field + header', 'theme': 'layout2' },
      { 'url': 'search-bars/2', 'title': 'Field + header 2', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Search With Map',
      'title': 'Destonation',
      'map': {
        'lat': 40.712562,
        'lng': -74.005911,
        'zoom': 15,
        'mapTypeControl': true,
        'streetViewControl': true
      },
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': '8 km to center',
          'price': '$ 340 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'title': 'Encore Macau',
          'subtitle': '8 km to center',
          'price': '$ 200 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'title': 'Bulgari Hotel London',
          'subtitle': '8 km to center',
          'price': '$ 500 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Belmond El Encanto',
          'subtitle': '8 km to center',
          'price': '$ 100 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'The Alpina Gstaad',
          'subtitle': '8 km to center',
          'price': '$ 600 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Field + header',
      'title': 'Hotels',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': '2 beds',
          'price': '$ 20 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/8.jpg',
          'shareIcon': 'share-social'
        },
        {
          'id': 2,
          'avatar': 'assets/imgs/avatar/23.jpg',
          'title': 'Encore Macau',
          'subtitle': '3 beds',
          'price': '$ 700 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/9.jpg',
          'shareIcon': 'share-social'
        },
        {
          'id': 3,
          'avatar': 'assets/imgs/avatar/21.jpg',
          'title': 'Bulgari Hotel London',
          'subtitle': '2 beds',
          'price': '$ 300 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/6.jpg',
          'shareIcon': 'share-social'
        },
        {
          'id': 4,
          'avatar': 'assets/imgs/avatar/22.jpg',
          'title': 'Belmond El Encanto',
          'subtitle': '1 beds',
          'price': '$ 500 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/5.jpg',
          'shareIcon': 'share-social'
        },
        {
          'id': 5,
          'avatar': 'assets/imgs/avatar/24.jpg',
          'title': 'The Alpina Gstaad',
          'subtitle': '3 beds',
          'price': '$ 400 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/7.jpg',
          'shareIcon': 'share-social'
        },
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Field + header 2',
      'headerImage': 'assets/imgs/background/3.jpg',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': 'LONDON, UNITED KINGDOM',
          'image': 'assets/imgs/background/5.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 2,
          'title': 'The Alpina Gstaad',
          'subtitle': 'GSTAAD, SWITZERLAND',
          'image': 'assets/imgs/background/6.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 3,
          'title': 'Belmond El Encanto',
          'subtitle': 'SANTA BARBARA, CALIFORNIA',
          'image': 'assets/imgs/background/7.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 4,
          'title': 'Casa Palmero',
          'subtitle': 'PEBBLE BEACH, CALIFORNIA',
          'image': 'assets/imgs/background/8.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 5,
          'title': 'Encore Macau',
          'subtitle': 'MACAU, CHINA',
          'image': 'assets/imgs/background/9.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 6,
          'title': 'Nobu Ryokan Malibu',
          'subtitle': 'MALIBU, CALIFORNIA',
          'image': 'assets/imgs/background/5.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('searchBars/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
